import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
    MdArticle,
    MdCalendarMonth,
    MdOndemandVideo,
    MdOutlineLocalLibrary,
    MdOutlinePeopleAlt,
    MdSchool,
    MdLeaderboard,
    MdPayment
} from 'react-icons/md';
import { useAuthContext } from 'context/AuthContext';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';
import './index.css';

function Hamburger({ transparent }: { transparent: boolean; }) {
    const [open, setOpen] = useState(false);

    const ref = useOutsideClickHandler(() => setOpen(false));

    const { user } = useAuthContext();

    if (!user) return <></>;

    return (
        <button className={
            open ? 'hamburger--open' : transparent ? 'hamburger--transparent' : 'hamburger'} 
            onClick={() => setOpen(!open)}
            ref={ref}
        >
            <div className='hamburger__top'></div>
            <div className='hamburger__mid'></div>
            <div className='hamburger__bot'></div>
            <div className={open ? 'hamburger__menu--open' : 'hamburger__menu'} ref={ref}>
                <NavLink 
                    to='/students'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    <MdOutlinePeopleAlt className='hamburger__menuItemIcon' />
                    Students
                </NavLink>
                <NavLink 
                    to='/tests'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    <MdArticle className='hamburger__menuItemIcon' />
                    Tests
                </NavLink>
                <NavLink 
                    to='/assignments'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    <MdCalendarMonth className='hamburger__menuItemIcon' />
                    Assignments
                </NavLink>
                {user.customizations.find(customization => customization === 'Video Lectures') && 
                    <NavLink
                        to='/lectures'
                        className={({ isActive }) => (
                            isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                        )}
                    >
                        <MdOndemandVideo className='hamburger__menuItemIcon' />
                        Lectures
                    </NavLink>
                }
                <NavLink 
                    to='/latestScores'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    <MdLeaderboard className='hamburger__menuItemIcon' />
                    Latest Scores
                </NavLink>
                {(user.role === 'Admin' || user.role === 'Super Admin' || user.role === 'Staff') && <>
                    <NavLink 
                        to='/instructors'
                        className={({ isActive }) => (
                            isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                        )}
                    >
                        <MdSchool className='hamburger__menuItemIcon' />
                        Instructors
                    </NavLink>
                    <NavLink 
                        to='/classes'
                        className={({ isActive }) => (
                            isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                        )}
                    >
                        <MdOutlineLocalLibrary className='hamburger__menuItemIcon' />
                        Classes
                    </NavLink>
                    <NavLink
                        to='/credits'
                        className={({ isActive }) => (
                            isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                        )}
                    >
                        <MdPayment className='hamburger__menuItemIcon' />
                        Credits
                    </NavLink>
                </>}
            </div>
        </button>
    );
}

export default Hamburger;